import { render, staticRenderFns } from "./MoreLoading.vue?vue&type=template&id=89174b0a"
import script from "./MoreLoading.vue?vue&type=script&lang=js"
export * from "./MoreLoading.vue?vue&type=script&lang=js"
import style0 from "./MoreLoading.vue?vue&type=style&index=0&id=89174b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports